import { Paper, Table, TableCell, TableHead, TableRow } from "@mui/material";
import { TableWrapper } from "./styled";
import { BaseTablePropsType } from "../../types/component.type";

export const BaseTable: React.FC<BaseTablePropsType> = ({
	headers,
	children,
}) => {
	return (
		<TableWrapper component={Paper}>
			<Table>
				{headers && headers.length > 0 && (
					<TableHead>
						<TableRow>
							{headers.map((header, index) => {
								return <TableCell key={index}>{header}</TableCell>;
							})}
						</TableRow>
					</TableHead>
				)}
				{children}
			</Table>
		</TableWrapper>
	);
};
